<ion-app class="" [ngClass]="{
  'top-safe-area': platform.is('ios'),
  'ios-safe-right-area-landscape': platformIsIOS &&
  isLandscape &&
  (
    router?.url?.includes('escuela/') ||
    ( router?.url?.includes('induccion/') && router?.url?.includes('tema/') ) ||
    ( router?.url?.includes('opciones-curso/') && router?.url?.includes('presentacion') )
  )
  && !router.url?.includes('beneficio/')
}">
	<!-- <ion-router-outlet
    id="main"
  ></ion-router-outlet> -->

 <ng-container *ngIf="!router.url.includes('/auth/login/external') &&
  showImpersonationBar &&
  router.url != '/login' &&
  router.url != '/login-loading' &&
  !capacitorSafe.isInIframe()"
  >
	<ion-header  mode="md">
		<ion-toolbar mode="ios" class="impersonation-toolbar">
      <div class="flex justify-center items-center px-4 h-[26px]">
        <span class="text-sm text-white">{{impersonationBarTitle}}</span>
        <button class="flex items-center gap-3 absolute right-4" (click)="logoutImpersonation()">
          <span class="text-white font-medium text-sm">Salir</span>
					<ion-icon name="exit-outline" class="text-white font-bold text-sm leading-[13px]"></ion-icon>
        </button>
      </div>
		  </ion-toolbar>
		</ion-header>
  </ng-container>

  <ng-container *ngIf="!networkIsActive">
    <!--   && !mobileMenuIsOpen   -->
    <div class="flex items-center justify-center gap-3 text-xs text-white px-4 py-1 bg-[#6CC7E6] font-medium md:text-sm absolute top-0 left-0 right-0 z-[9999999999999999999]" ><mat-icon class="mdi mdi-earth-off offline-icon-bar"></mat-icon>
      {{ language === 'es' ? 'Estás en modo offline' : 'You are offline'}}
    </div>
  </ng-container>
  <!-- <div class="bg-red-400 w-full z-5">
    <button class="bg-blue-200 px-4" (click)="languageService.changeLanguage('es')">ES</button>
    <button  class="bg-red-200 px-4" (click)="languageService.changeLanguage('en')">EN</button>
  </div> -->
<app-side-menu-mobile [dataUsuarioProp]="userProfileData"  [initialsProp]="initials" (menuIsOpen)="onMenuIsOpen($event)"></app-side-menu-mobile>
	<ion-router-outlet
		id="main"
		class="lg:mb-0"
		[ngClass]="{
			'mb-[3.6rem]':
        keyboardHidden &&
        !loadingScreenIsActive &&
				router.url != '/login' &&
				!router.url.includes('login-loading') &&
				!router.url.includes('recuperar-contrasenia') &&
				!router.url.includes('login-ayuda') &&
				!router.url.includes('cambiar-contrasenia') &&
				!router.url.includes('ayuda-coordinador') &&
				!router.url.includes('solicitud-enviada') &&
				!router.url.includes('validacion-usuario') &&
				!router.url.includes('validacion-quiz') &&
				!router.url.includes('error-validacion') &&
				!router.url.includes('evaluacion-curso') &&
				!router.url.includes('encuesta-preguntas') &&
				!router.url.includes('vademecum/scorm') &&
				!router.url.includes('slides-bienvenida') &&
				!router.url.includes('auth/login/external') &&
				!router.url.includes('register?c') &&
        !router.url.includes('validador-evaluacion') &&
        !router.url.includes('scorm-player') &&
        !router.url.includes('app-scorm-player') &&
        !router.url.includes('app-scorm-player-2') &&
        !router.url.includes('encuestas?') &&
        !router.url.includes('encuestas/') &&
        !router.url.includes('politica-privacidad') &&
        !router.url.includes('condiciones-del-servicio') &&
        !router.url.includes('terms-calendar') &&
        !router.url.includes('privacy-calendar') &&
        !router.url.includes('about') &&
        !router.url.includes('login-workspace') &&
        !router.url.includes('youtube-embed') &&
        !router.url.includes('verify-company') &&
        !router.url.includes('vimeo-embed') &&
				!fullscreen,
			'mr-0-i': router.url.includes('vista-conferencia'),
			'full': fullscreen,
			'mt-[29px]': router.url != '/login' &&
					router.url != '/login-loading' &&
					router.url != '/auth/login/external' &&
					showImpersonationBar ,
      'mt-[30px]': !networkIsActive,
      'remove-margin-b': isLandscape &&
      (
        router?.url?.includes('escuela/') ||
        ( router?.url?.includes('induccion/') && router?.url?.includes('tema/') ) ||
        ( router?.url?.includes('opciones-curso/') && router?.url?.includes('presentacion') )
      )
      && !router.url?.includes('beneficio/')
		}"
	>
	<!-- <app-notification-modal *ngIf="showNotification" [from]="showNotificationFrom"></app-notification-modal> -->
  </ion-router-outlet>

	<!-- <app-side-menu *ngIf="router.url != '/login' && router.url != '/login-loading' && router.url != '/vista-conferencia'"></app-side-menu> -->
	<app-footer-tab
		[platformIsIOS]="platformIsIOS"
		class="bottom-0 absolute  w-full"
		*ngIf="
      !loadingScreenIsActive &&
			router.url != '/splash-screen' &&
			router.url != '/login' &&
			!router.url.includes('login-loading') &&
			!router.url.includes('recuperar-contrasenia') &&
			!router.url.includes('login-ayuda') &&
			!router.url.includes('cambiar-contrasenia') &&
			!router.url.includes('ayuda-coordinador') &&
			!router.url.includes('solicitud-enviada') &&
			!router.url.includes('validacion-usuario') &&
			!router.url.includes('validacion-quiz') &&
			!router.url.includes('error-validacion') &&
			!router.url.includes('evaluacion-curso') &&
			!router.url.includes('encuesta-preguntas') &&
			!router.url.includes('slides-bienvenida') &&
			!router.url.includes('vademecum/scorm') &&
			!router.url.includes('auth/login/external') &&
			!router.url.includes('register?c') &&
			!router.url.includes('validador-evaluacion') &&
			!router.url.includes('scorm-player') &&
			!router.url.includes('app-scorm-player') &&
			!router.url.includes('app-scorm-player-2') &&
      !router.url.includes('encuestas?') &&
      !router.url.includes('encuestas/') &&
      !router.url.includes('login-workspace') &&
      !router.url.includes('politica-privacidad') &&
      !router.url.includes('condiciones-del-servicio') &&
      !router.url.includes('terms-calendar') &&
      !router.url.includes('privacy-calendar') &&
      !router.url.includes('about') &&
      !router.url.includes('youtube-embed') &&
      !router.url.includes('verify-company') &&
      !router.url.includes('vimeo-embed') &&
			keyboardHidden && !fullscreen
		"
    [ngClass]="{'hidden': isLandscape &&
      (
        router?.url?.includes('escuela/') ||
        ( router?.url?.includes('induccion/') && router?.url?.includes('tema/') ) ||
        ( router?.url?.includes('opciones-curso/') && router?.url?.includes('presentacion') )
      )
      && !router.url?.includes('beneficio/')
    }"
	></app-footer-tab>

	<!-- Modal: notificaciones desactivadas -> redirigir a ajustes -->
	<app-base-modal
		[isOpen]="pushPermissionModalIsOpen"
		(closeModal)="closePushPermissionModal()"
		customStyle="w-11/12 sm:w-84"
		ionClass="add-backdrop"
	>
		<div class="w-full flex flex-col items-center text-center px-6 py-7">
			<mat-icon class="mdi mdi-bell-cog-outline text-primary !text-5xl !w-12 !h-12 leading-none mb-4"></mat-icon>
			<b class="text-xl text-gray-800 mb-2">
				{{ language === 'es' ? 'Activa tus notificaciones' : 'Turn on notifications' }}
			</b>
			<p class="text-base text-gray-500 mb-6">
				{{ language === 'es'
					? 'Las notificaciones están desactivadas. Actívalas para no perderte novedades y recordatorios importantes.'
					: 'Notifications are turned off. Enable them so you don’t miss important updates and reminders.' }}
			</p>
			<button
				(click)="goToNotificationSettings()"
				class="w-full bg-primary text-white font-medium rounded-lg py-3 mb-3"
			>
				{{ language === 'es' ? 'Ir a ajustes' : 'Go to settings' }}
			</button>
			<button
				(click)="closePushPermissionModal()"
				class="bg-transparent text-gray-400 font-medium py-1"
			>
				{{ language === 'es' ? 'Ahora no' : 'Not now' }}
			</button>
		</div>
	</app-base-modal>
</ion-app>


